import React, { useState, useEffect } from "react";
import { useDirectMessageContext } from "@/context/DirectMessageContext";
import DirectMessagePopup from "./DirectMessagePopup";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return isMobile;
};

const DirectMessageContainer: React.FC = () => {
  const { openChats } = useDirectMessageContext();
  const isMobile = useIsMobile();

  if (openChats.length === 0) return null;

  // On mobile: only show the last opened chat (fullscreen)
  if (isMobile) {
    const lastChat = openChats[openChats.length - 1];
    return (
      <DirectMessagePopup
        key={lastChat.userId}
        userId={lastChat.userId}
        userName={lastChat.userName}
        avatarUrl={lastChat.avatarUrl}
      />
    );
  }

  // Desktop: show all chats side by side
  return (
    <>
      {openChats.map((chat, index) => (
        <DirectMessagePopup
          key={chat.userId}
          userId={chat.userId}
          userName={chat.userName}
          avatarUrl={chat.avatarUrl}
          style={{ right: `${260 + index * 490}px` }}
        />
      ))}
    </>
  );
};

export default DirectMessageContainer;
